import React from 'react';
import { LocationModel } from 'models/CompanySetup/location.model';
import { AddressModel } from 'models/CompanySetup/address.model';
import clsx from 'clsx';
import styles from '../../CompanySetup/ParentPage/Modals/LocationModal.module.scss';
import {
  LocationTableStrings,
  LocationTableFields,
} from 'enums/CompanySetupEnums';
import { SortingProps } from '.';
import { TableColumnsType } from 'antd';
import { SortingTypesEnums } from 'enums/sortingTypes.enum';
import { SortOrder } from 'antd/lib/table/interface';

export const sortDirectionMap: {
  [key: string]:
    | SortingTypesEnums.ASCEND
    | SortingTypesEnums.DESCEND
    | undefined;
} = {
  '': SortingTypesEnums.ASCEND,
  ascend: SortingTypesEnums.DESCEND,
  descend: undefined,
};

const LocationTableColumns = (props: {
  sortedInfo: SortingProps;
}): TableColumnsType<LocationModel> => {
  const { sortedInfo } = props;

  const getSortOrder = (fieldName: string) => {
    return sortedInfo?.columnKey === fieldName
      ? (sortedInfo?.order as SortOrder)
      : null;
  };
  return [
    {
      title: LocationTableStrings.LOCATION_NAME,
      dataIndex: LocationTableFields.NAME,
      key: LocationTableFields.NAME,
      sorter: true,
      sortOrder: getSortOrder(LocationTableFields.NAME),
    },
    {
      title: LocationTableStrings.ORGANIZATION,
      key: `${LocationTableFields.ORGANIZATION}.${LocationTableFields.ORGANIZATION_NAME}`,
      dataIndex: [
        LocationTableFields.ORGANIZATION,
        LocationTableFields.ORGANIZATION_NAME,
      ],
      render: (name: string) => <div className="text-capitalize">{name}</div>,
      sorter: true,
      sortOrder: getSortOrder(
        `${LocationTableFields.ORGANIZATION}.${LocationTableFields.ORGANIZATION_NAME}`
      ),
    },
    {
      title: LocationTableStrings.ORGANIZATION_BOUNDARY,
      dataIndex: LocationTableFields.SHAREERCENTAGE,
      key: LocationTableFields.SHAREPERCENTAGE,
      render: (val: string) => (
        <div>
          {val ?? 0} {LocationTableStrings.PERCENTAGE_SIGN}
        </div>
      ),
      sorter: true,
      sortOrder: getSortOrder(LocationTableFields.SHAREPERCENTAGE),
    },
    {
      title: LocationTableStrings.TYPE,
      dataIndex: LocationTableFields.CATEGORY,
      key: LocationTableFields.CATEGORY,
      sorter: true,
      sortOrder: getSortOrder(LocationTableFields.CATEGORY),
    },
    {
      title: LocationTableStrings.ADDRESS,
      dataIndex: LocationTableFields.ADDRESS,
      key: LocationTableFields.FULLADDRESS,
      render: (address: AddressModel) => <div>{address.getFullAddress()}</div>,
      sorter: true,
      sortOrder: getSortOrder(LocationTableFields.FULLADDRESS),
    },
    {
      title: LocationTableStrings.ACTIONS,
      width: 150,
      key: LocationTableFields.STATUS,
      render: (_text: string, record: LocationModel) => (
        <div
          className={clsx(styles.status, {
            [styles.statusComplete]: record.isCompleted,
            [styles.statusIncomplete]: !record.isCompleted,
          })}>
          {record.isCompleted
            ? LocationTableStrings.COMPLETED
            : LocationTableStrings.INCOMPLETE}
        </div>
      ),
      sorter: true,
      sortOrder: getSortOrder(LocationTableFields.STATUS),
    },
  ];
};

export default LocationTableColumns;
